import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-reporting-actions-renderer',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <div class="actions-container">
      <button class="actionButton viewButton" mat-mini-fab data-action="view" title="View Template">
        <mat-icon data-action="view">visibility</mat-icon>
      </button>
      <button class="actionButton runButton" mat-mini-fab data-action="run" title="Run Report">
        <mat-icon data-action="run">directions_run</mat-icon>
      </button>
      <button class="actionButton scheduleButton" mat-mini-fab data-action="schedule" title="Schedule Report">
        <mat-icon data-action="schedule">schedule</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .actions-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      gap: 4px;
    }
    .actionButton {
      cursor: pointer;
    }
    .viewButton {
      background-color: #0099ab;
      color: white;
    }
    .runButton {
      background-color: #0099ab;
      color: white;
    }
    .scheduleButton {
      background-color: #0099ab;
      color: white;
    }
  `],
})
export class ReportingActionsRendererComponent implements ICellRendererAngularComp {
  agInit(_params: ICellRendererParams): void {}

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
